import { Conditions } from '../api/graphql/master/types';
import { SubscriptionLineApiType } from '../types/api/SubscriptionApiType';
import { ParentParams } from '../types/constant/PagesPropsType';

export type CategoryContext = {
  skuArr: string[];
  totalPrice: number;
  continueCount: number;
  customerTags: ParentParams['customerTags'];
  totalSpent: number;
};

export function checkConditions(c: Conditions | undefined, ctx: CategoryContext) {
  // 設定がない場合は表示
  if (!c) return true;

  // conditions はあるが中身が空 → false
  if (Object.keys(c).length === 0) return false;

  // customerTags
  if (c.customerTags) {
    if (!ctx.customerTags.includes(c.customerTags)) return false;
  }

  // totalSpent
  if (c.totalSpent) {
    if (ctx.totalSpent <= Number(c.totalSpent)) return false;
  }

  // containsSku
  if (c.containsSku) {
    const arr = c.containsSku.split(',');
    if (!arr.some((sku) => ctx.skuArr.includes(sku))) return false;
  }

  // notContainsSku
  if (c.notContainsSku) {
    const arr = c.notContainsSku.split(',');
    if (arr.some((sku) => ctx.skuArr.includes(sku))) return false;
  }

  // contractPriceAmountMore（以上）
  if (c.contractPriceAmountMore) {
    if (ctx.totalPrice < Number(c.contractPriceAmountMore)) return false;
  }

  // contractPriceAmountLess（未満）
  if (c.contractPriceAmountLess) {
    if (ctx.totalPrice >= Number(c.contractPriceAmountLess)) return false;
  }

  // orderCountMore（以上）
  if (c.orderCountMore) {
    if (ctx.continueCount < Number(c.orderCountMore)) return false;
  }

  // orderCountLess（未満）
  if (c.orderCountLess) {
    if (ctx.continueCount >= Number(c.orderCountLess)) return false;
  }

  // すべて通過したら表示
  return true;
}

export function createCategoryContext(
  subscriptionLines: SubscriptionLineApiType[],
  totalOrderCount: number,
  customerTags: string[],
  totalSpent: string
): CategoryContext {
  let totalPrice = 0;
  const skuArr: string[] = [];

  for (let i = 0; i < subscriptionLines.length; i++) {
    const l = subscriptionLines[i];
    totalPrice += l.currentPriceAmount * l.quantity;
    skuArr.push(l.sku);
  }

  return {
    skuArr,
    totalPrice,
    continueCount: totalOrderCount + 1,
    customerTags: customerTags ?? [],
    totalSpent: Number(totalSpent ?? 0),
  };
}
